export const Constants = {
    JOINT_CLASSES: 'JointClasses',
    MULTI_PERIODS: 'MultiPeriods',
    TEACHERS_AND_TAS_FOR_SUBJECTS: 'TeachersAndTAsForSubjects',
    TEACHERS_AND_TAS_FOR_ELECTIVES: 'TeachersAndTAsForElectives',
    FIXED_TEACHERS_AND_TAS_FOR_SUBJECTS: 'FixedTeachersAndTAsForSubjects',
    FIXED_TEACHERS_AND_TAS_FOR_ELECTIVES: 'FixedTeachersAndTAsForElectives',
    PREFERRED_PERIODS: 'PreferredPeriods',
    REQUIRED_SHARED_ROOM_FOR_SUBJECTS: 'RequiredSharedRoomForSubjects',
    REQUIRED_SHARED_ROOM_FOR_ELECTIVES: 'RequiredSharedRoomForElectives',
}